import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { FileUploader, SelectBox } from "devextreme-react";
import Utils from "Utils";
import Api from "Api/Api";

function TaskRunner(props) {
  const [canRun, setCanRun] = useState(true);
  const [canUpload, setCanUpload] = useState(true);
  const [templateLinks, setTemplateLinks] = useState({
    investor: "",
    startup: "",
  });
  const [startupList, setStartupList] = useState([]);
  const [selectedStartup, setSelectedStartup] = useState(null);

  useEffect(() => {
    props.dispatch({
      type: "SectionSelected",
      payload: "Task Runner",
    });
    checkStatus();
    Api.getBulkInvestorTemplateLinks().then((response) => {
      if (response.status === 200) {
        setTemplateLinks({
          investor: response.data.investor,
          startup: response.data.startup,
        });
      }
    });
    loadStartups();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const runTask = () => {
    Api.runAllMatchTask().then((response) => {
      if (response.status === 200) {
        setCanRun(false);
      }
    });
  };

  const checkStatus = (type = "upload") => {
    Api.checkAllMatchTaskStatus(type).then((response) => {
      if (response.status === 200) {
        if (type === "upload") {
          setCanRun(response.data === "Complete");
        } else {
          setCanUpload(response.data === "Complete");
        }
      }
    });
  };

  const runBulkCommand = (e) => {
    e.preventDefault();
    var forms = document.forms["bulkInvestor"];
    var data = new FormData();
    if (forms.file.files[0]) {
      data.append("file", forms.file.files[0]);
      props.dispatch({ type: "toggleLoad" });
      Api.bulkUploadInvestor(data).then((response) => {
        props.dispatch({ type: "toggleLoad" });
        if (response.status === 200) {
          Utils.notify("Command is running in the background!", "info");
          setCanUpload(false);
        }
      });
    }
  };

  const loadStartups = async (text = "") => {
    let filter = { text };
    const response = await Api.getAllStartups(1, filter);
    if (response.status === 200) {
      const filteredResults = Utils.addUniqueObjectToArray(
        startupList,
        response.data.results,
        "id"
      );
      setStartupList([...filteredResults, ...startupList]);
    }
  };

  const runScriptForStartup = async () => {
    const response = await Api.runMatchScriptForStartup(selectedStartup);
    if (response.status === 200) {
      Utils.notify("Command is running in the background!", "info");
    }
  };

  const onSearchInput = (e) => {
    const inpValue = e.element.querySelectorAll("input")[1].value;
    Utils.debounce(loadStartups(inpValue), 300);
  };

  return (
    <div className="taskRunner">
      <div className="warningMessage">
        <h2>DANGER ZONE!</h2>
        <h4>
          <b>WARNING:-</b> Run this task only when servers are less busy! This
          will take long time to run and server may get busy. If you try to
          access the server during this time, it may{" "}
          <span style={{ color: "red" }}>CRASH!</span>
        </h4>
      </div>
      <hr />
      <div className="matchCreator">
        <h3>Match creator</h3>
        <button
          className={`btn btn-danger mr-3 ${
            canRun ? "pointer" : "cursor-disabled"
          }`}
          disabled={!canRun}
          onClick={() => {
            runTask();
          }}
        >
          Run Task
        </button>
        <button
          className={`btn btn-info`}
          onClick={() => {
            checkStatus();
          }}
        >
          Check Status
        </button>
        <h4>
          {canRun
            ? "You can run the task! But beware of the warning above!"
            : "Task Running! Please Wait!"}
        </h4>
      </div>
      <hr />
      <div className="bulkUploader">
        <h3>Bulk Investor Uploader</h3>
        <ol>
          <li>
            You can download the template file to upload bulk investors and
            startup.
          </li>
          <li>
            Please follow all the standards as mentioned in the file template
            itself!
          </li>
          <li>
            Avoiding the standard can cause, problems while storing the data in
            the backend
          </li>
          <li>
            Upload the data using the uploader and you can check the status of
            the task using the button.
          </li>
        </ol>
        <div className="flex flex-column text-capitalize">
          {Object.keys(templateLinks).map((key) => {
            return (
              <a href={templateLinks[key]} download>
                {key}'s Template
              </a>
            );
          })}
        </div>
        <form onSubmit={runBulkCommand} name="bulkInvestor">
          <div className="col-lg-1">
            <h5>Updated file</h5>
          </div>
          <div className="col-lg-5">
            <FileUploader name={"file"} uploadMode={"useForm"} />
          </div>
          <button
            className={`btn btn-danger mr-3 ${
              canUpload ? "pointer" : "cursor-disabled"
            }`}
            disabled={!canUpload}
            type="submit"
          >
            Upload
          </button>
        </form>
        <button
          className={`btn btn-info`}
          onClick={() => {
            checkStatus();
          }}
        >
          Check Status
        </button>
      </div>
      <hr />
      <div className="startupScriptRunner">
        <h3>Run match script for startup</h3>
        <p>You can run match-making script for any specific startup!</p>
        <SelectBox
          width="20%"
          className="mr-3"
          placeholder="Select startup"
          dataSource={startupList}
          valueExpr={"id"}
          displayExpr={"name"}
          searchEnabled={true}
          searchExpr={"name"}
          onInput={onSearchInput}
          // defaultValue={filters?.sort}
          onValueChanged={(e) => setSelectedStartup(e.value)}
        />
        <button
          className={`btn btn-primary mt-3`}
          onClick={runScriptForStartup}
        >
          Run script
        </button>
      </div>
    </div>
  );
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps)(TaskRunner);
